// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1AYcQ","content":"LayoutSettings_content__2BAoG"};